import { createEvent, restore, sample } from 'effector'
import { libraryGridPurchasedMoviesWidget } from '~/widgets/library/grid/purchased/movies'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridPurchasedMoviesWidget.$isGridPurchasedMoviesLoading,
  target: setContentLoading,
})
